import * as React from "react";
import classnames from "classnames";
import Link from "../../../../Link/Link/Link.js";
import CardText from "./CardText.js";
const CardLink = ({
  children,
  className,
  target,
  variant = "body-head",
  component = "span",
  ...rest
}) => /* @__PURE__ */ React.createElement(CardText, { component, variant }, /* @__PURE__ */ React.createElement(Link, { className: classnames("card-link", className), ...rest }, children));
export {
  CardLink as default
};
//# sourceMappingURL=CardLink.js.map
